import { ClipboardModule } from '@angular/cdk/clipboard';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { RouterModule } from '@angular/router';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { QRCodeModule } from 'angularx-qrcode';
import { RecaptchaModule } from 'ng-recaptcha';
import { ColorPickerModule } from 'ngx-color-picker';
import { FileSaverModule } from 'ngx-filesaver';
import { NgxPayPalModule } from 'ngx-paypal';
import { NgxSpinnerModule } from 'ngx-spinner';

import { DmsFooterComponent } from '../dms/dms-footer/dms-footer.component';
import { DmsHeaderComponent } from '../dms/dms-header/dms-header.component';
import { AlertComponent } from './components/alert/alert.component';
import { AutocompleteComponent } from './components/autocomplete/autocomplete.component';
import { BonificoDetailsModalComponent } from './components/bonifico-details-modal/bonifico-details-modal.component';
import { CalendarV2BottomSheetComponent } from './components/calendar-v2-bottom-sheet/calendar-v2-bottom-sheet.component';
import { CalendarV2Component } from './components/calendar-v2/calendar-v2.component';
import { CalendarComponent } from './components/calendar/calendar.component';
import { ClienteLoginComponent } from './components/cliente-login/cliente-login.component';
import { ClienteSelectComponent } from './components/cliente-select/cliente-select.component';
import { ColorPickerComponent } from './components/color-picker/color-picker.component';
import {
  CreaPagamentoBonificoModalComponent,
} from './components/crea-pagamento/crea-pagamento-bonifico-modal/crea-pagamento-bonifico-modal.component';
import {
  CreaPagamentoCartaCreditoModalComponent,
} from './components/crea-pagamento/crea-pagamento-carta-credito-modal/crea-pagamento-carta-credito-modal.component';
import { CreaPagamentoComponent } from './components/crea-pagamento/crea-pagamento.component';
import { PaypalModalComponent } from './components/crea-pagamento/paypal-modal/paypal-modal.component';
import { StripeModalComponent } from './components/crea-pagamento/stripe-modal/stripe-modal.component';
import { XpayCardModalComponent } from './components/crea-pagamento/xpay-card-modal/xpay-card-modal.component';
import {
  CssConfigurationUbicazioniIstatComponent,
} from './components/css-configuration-ubicazioni-istat/css-configuration-ubicazioni-istat.component';
import { CssConfigurationComponent } from './components/css-configuration/css-configuration.component';
import { CssEditorComponent } from './components/css-editor/css-editor.component';
import { CustomCheckboxComponent } from './components/custom-checkbox/custom-checkbox.component';
import {
  CustomEditorTextareaComponent,
} from './components/custom-editor/custom-editor-textarea/custom-editor-textarea.component';
import {
  CustomEditorToolbarSelectComponent,
} from './components/custom-editor/custom-editor-toolbar-select/custom-editor-toolbar-select.component';
import {
  CustomEditorToolbarComponent,
} from './components/custom-editor/custom-editor-toolbar/custom-editor-toolbar.component';
import { CustomEditorComponent } from './components/custom-editor/custom-editor.component';
import { DialogInfoComponent } from './components/dialog-info/dialog-info.component';
import { EditorNewComponent } from './components/editor-new/editor-new.component';
import { EditorComponent } from './components/editor/editor.component';
import { EmailSendComponent } from './components/email-send/email-send.component';
import { FormV1Component } from './components/form-v1/form-v1.component';
import {
  PrivacyNewsletterDialogComponent,
} from './components/form-v1/privacy-newsletter-dialog/privacy-newsletter-dialog.component';
import { GiorniSelectComponent } from './components/giorni-select/giorni-select.component';
import { HeaderComponent } from './components/header/header.component';
import { HtmlEditorDialogComponent } from './components/html-editor-dialog/html-editor-dialog.component';
import { IconsDialogComponent } from './components/icons-dialog/icons-dialog.component';
import { ImageEditComponent } from './components/image-edit/image-edit.component';
import { ImageLibraryComponent } from './components/image-library/image-library.component';
import { ImageSliderGalleryComponent } from './components/image-slider/image-slider-gallery/image-slider-gallery.component';
import { ImageSliderComponent } from './components/image-slider/image-slider.component';
import { ImageComponent } from './components/image/image.component';
import { ImagesListEditComponent } from './components/images-list-edit/images-list-edit.component';
import { IndeterminateCheckboxComponent } from './components/indeterminate-checkbox/indeterminate-checkbox.component';
import { InnerHtmlComponent } from './components/inner-html/inner-html.component';
import { ListSelectComponent } from './components/list-select/list-select.component';
import { MessaggiSendComponent } from './components/messaggi-send/messaggi-send.component';
import { MessaggioSendComponent } from './components/messaggio-send/messaggio-send.component';
import { MultipleSelectComponent } from './components/multiple-select/multiple-select.component';
import { CreditCardComponent } from './components/pagamento-form/credit-card/credit-card.component';
import {
  PagamentoFormDialogComponent,
} from './components/pagamento-form/pagamento-form-dialog/pagamento-form-dialog.component';
import {
  PagamentoFormErrorComponent,
} from './components/pagamento-form/pagamento-form-error/pagamento-form-error.component';
import {
  PagamentoFormSuccessComponent,
} from './components/pagamento-form/pagamento-form-success/pagamento-form-success.component';
import { PagamentoFormComponent } from './components/pagamento-form/pagamento-form.component';
import { PaymentFormComponent } from './components/pagamento-form/payment-form/payment-form.component';
import {
  PaymentWindowErrorComponent,
} from './components/pagamento-form/payment-window-error/payment-window-error.component';
import { PopupCheckComponent } from './components/pagamento-form/popup-check/popup-check.component';
import { PrintComponent } from './components/print/print.component';
import { QrCodeModalComponent } from './components/qr-code-modal/qr-code-modal.component';
import { RichiesteAddComponent } from './components/richieste-add/richieste-add.component';
import { SelectSearchComponent } from './components/select-search/select-search.component';
import { SmsSendComponent } from './components/sms-send/sms-send.component';
import { StoricoClienteComponent } from './components/storico-cliente/storico-cliente.component';
import { SvgComponent } from './components/svg/svg.component';
import { TableComponent } from './components/table/table.component';
import { TemplatePreviewComponent } from './components/template-preview/template-preview.component';
import { TemplateTooltipComponent } from './components/template-tooltip/template-tooltip.component';
import {
  TipoCameraTariffaDetailsDialogComponent,
} from './components/tipo-camera-tariffa-details-dialog/tipo-camera-tariffa-details-dialog.component';
import { UrlComponent } from './components/url/url.component';
import { ViewSelectDialogComponent } from './components/view-select/view-select-dialog/view-select-dialog.component';
import { ViewSelectComponent } from './components/view-select/view-select.component';
import { AutocompleteOffDirective } from './directives/autocomplete-off.directive';
import { AutofocusDirective } from './directives/autofocus.directive';
import { GoogleSigninButtonDirective } from './directives/google-signin-button.directive';
import { InvertColorDirective } from './directives/invert-color.directive';
import { RectangleDirective } from './directives/rectangle.directive';
import { TemplateTooltipDirective } from './directives/template-tooltip.directive';
import { CapitalizePipe } from './pipes/capitalize.pipe';
import { EurCurrencyPipe } from './pipes/eur-currency.pipe';
import { MomentFormatPipe } from './pipes/moment-format.pipe';
import { NightsPipe } from './pipes/nights.pipe';
import { ReplacePipe } from './pipes/replace-pipe';
import { SafeHtmlPipe } from './pipes/safehtml-pipe';
import { SafeUrlPipe } from './pipes/safeurl-pipe';
import { SelectEnumPipe } from './pipes/select-enum.pipe';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    MatCheckboxModule,
    MatButtonModule,
    MatInputModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatRadioModule,
    MatSelectModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatMenuModule,
    MatBadgeModule,
    MatSidenavModule,
    MatToolbarModule,
    MatListModule,
    MatGridListModule,
    MatCardModule,
    MatStepperModule,
    MatTabsModule,
    MatExpansionModule,
    MatButtonToggleModule,
    MatChipsModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatDialogModule,
    MatTooltipModule,
    MatSnackBarModule,
    MatTableModule,
    MatSortModule,
    DragDropModule,
    MatPaginatorModule,
    NgxSpinnerModule,
    RouterModule,
    ColorPickerModule,
    NgxPayPalModule,
    NgxChartsModule,
    AngularEditorModule,
    ClipboardModule,
    RecaptchaModule,
    QRCodeModule,
    MatTreeModule,
    MatBottomSheetModule
  ],
  declarations: [
    SafeHtmlPipe,
    SafeUrlPipe,
    SelectEnumPipe,
    EurCurrencyPipe,
    MomentFormatPipe,
    NightsPipe,
    RectangleDirective,
    InvertColorDirective,
    AutocompleteOffDirective,
    AutofocusDirective,
    ReplacePipe,
    GoogleSigninButtonDirective,
    TemplateTooltipComponent,
    TemplateTooltipDirective,
    HeaderComponent,
    DialogInfoComponent,
    AutocompleteComponent,
    CalendarComponent,
    CalendarV2Component,
    CalendarV2BottomSheetComponent,
    ColorPickerComponent,
    CssConfigurationComponent,
    DmsFooterComponent,
    DmsHeaderComponent,
    ImageSliderComponent,
    IconsDialogComponent,
    PagamentoFormComponent,
    PagamentoFormDialogComponent,
    FormV1Component,
    EmailSendComponent,
    EditorComponent,
    EditorNewComponent,
    MessaggiSendComponent,
    InnerHtmlComponent,
    RichiesteAddComponent,
    CreditCardComponent,
    ImageEditComponent,
    QrCodeModalComponent,
    PagamentoFormSuccessComponent,
    PagamentoFormErrorComponent,
    ImageSliderGalleryComponent,
    ImageLibraryComponent,
    ClienteSelectComponent,
    CreaPagamentoComponent,
    AlertComponent,
    SmsSendComponent,
    MessaggioSendComponent,
    TipoCameraTariffaDetailsDialogComponent,
    GiorniSelectComponent,
    PrintComponent,
    ViewSelectComponent,
    ViewSelectDialogComponent,
    BonificoDetailsModalComponent,
    ImageComponent,
    ImagesListEditComponent,
    HtmlEditorDialogComponent,
    TemplatePreviewComponent,
    StoricoClienteComponent,
    UrlComponent,
    StripeModalComponent,
    PaypalModalComponent,
    PopupCheckComponent,
    PaymentWindowErrorComponent,
    CssConfigurationUbicazioniIstatComponent,
    PrivacyNewsletterDialogComponent,
    IndeterminateCheckboxComponent,
    PaymentFormComponent,
    CssEditorComponent,
    SelectSearchComponent,
    XpayCardModalComponent,
    CreaPagamentoCartaCreditoModalComponent,
    CreaPagamentoBonificoModalComponent,
    CustomCheckboxComponent,
    MultipleSelectComponent,
    ListSelectComponent,
    ClienteLoginComponent,
    CustomEditorComponent,
    CustomEditorTextareaComponent,
    CustomEditorToolbarComponent,
    CustomEditorToolbarSelectComponent,
    TableComponent,
    SvgComponent,
    CapitalizePipe
  ],
  exports: [
    SafeHtmlPipe,
    SafeUrlPipe,
    SelectEnumPipe,
    EurCurrencyPipe,
    MomentFormatPipe,
    NightsPipe,
    RectangleDirective,
    InvertColorDirective,
    AutocompleteOffDirective,
    AutofocusDirective,
    ReplacePipe,
    GoogleSigninButtonDirective,
    TemplateTooltipDirective,
    MatCheckboxModule,
    MatCheckboxModule,
    MatButtonModule,
    MatInputModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatRadioModule,
    MatSelectModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatMenuModule,
    MatBadgeModule,
    MatSidenavModule,
    MatToolbarModule,
    MatListModule,
    MatGridListModule,
    MatCardModule,
    MatStepperModule,
    MatTabsModule,
    MatExpansionModule,
    MatButtonToggleModule,
    MatChipsModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatDialogModule,
    MatTooltipModule,
    MatSnackBarModule,
    MatTableModule,
    DragDropModule,
    MatSortModule,
    MatPaginatorModule,
    HeaderComponent,
    TranslatePipe,
    NgxSpinnerModule,
    FormsModule,
    ReactiveFormsModule,
    AutocompleteComponent,
    CalendarComponent,
    CalendarV2Component,
    CalendarV2BottomSheetComponent,
    ColorPickerComponent,
    CssConfigurationComponent,
    DmsFooterComponent,
    DmsHeaderComponent,
    ImageSliderComponent,
    IconsDialogComponent,
    PagamentoFormComponent,
    PagamentoFormDialogComponent,
    FormV1Component,
    NgxChartsModule,
    FileSaverModule,
    EditorComponent,
    EditorNewComponent,
    AngularEditorModule,
    MessaggiSendComponent,
    InnerHtmlComponent,
    ClipboardModule,
    RichiesteAddComponent,
    CreditCardComponent,
    ImageEditComponent,
    ImageLibraryComponent,
    QrCodeModalComponent,
    ClienteSelectComponent,
    CreaPagamentoComponent,
    AlertComponent,
    SmsSendComponent,
    MessaggioSendComponent,
    TipoCameraTariffaDetailsDialogComponent,
    GiorniSelectComponent,
    ViewSelectComponent,
    BonificoDetailsModalComponent,
    ImageComponent,
    ImagesListEditComponent,
    MatTreeModule,
    HtmlEditorDialogComponent,
    TemplatePreviewComponent,
    StoricoClienteComponent,
    UrlComponent,
    CssConfigurationUbicazioniIstatComponent,
    IndeterminateCheckboxComponent,
    CssEditorComponent,
    SelectSearchComponent,
    CustomCheckboxComponent,
    MultipleSelectComponent,
    ListSelectComponent,
    ClienteLoginComponent,
    TableComponent,
    SvgComponent,
    CapitalizePipe
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class SharedModule { }
